import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiResponse, BaseComponent} from 'compob2b-libs';
import {FileUploader} from 'ng2-file-upload';
import {from, Observable, Subscription} from 'rxjs';
import {concatMap, finalize, map, takeUntil, tap} from 'rxjs/operators';

interface DocumentFile {
  enabled: boolean;
  header: string;
  fileInput: File;
}

type FileUpload = {
  progress?: number,
  response?: ApiResponse<string>
};

@Component({
    selector: 'app-file-upload-dam',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent extends BaseComponent implements OnInit {
  @Input() uploadURI: string;
  @Output() onFileUnloaded: EventEmitter<FileUpload> = new EventEmitter();

  uploader: FileUploader;
  isUploading = false;
  finished = false;
  catalogId: number = 0;
  progress = 0;
  files = [];
  subscription: Subscription;

  constructor(protected readonly route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.uploader = new FileUploader({
      url: null,
      disableMultipart: false,
      formatDataFunctionIsAsync: false,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 4000 * 1024 * 1024,
    });

    this.route.queryParamMap.pipe(
      tap(params => {
        this.catalogId = Number(params.get('catalog_id') || 0);
        this.cdr.detectChanges();
      }),
      takeUntil(this.unsubscribe),
    ).subscribe();
  }

  getProgressStyle(progress: number) {
    return `stroke-dashoffset: calc(310 - (310 * ${progress}) / 100)`;
  }

  restart() {
    this.isUploading = false;
    this.finished = false;
    this.progress = 0;
    this.files = [];
    this.subscription.unsubscribe();
    this.uploader.clearQueue();
    this.cdr.detectChanges();
  }

  upload(): void {
    console.log('uploader event', this.uploader);
    this.isUploading = true;
    this.progress = 0;
    this.files = [];

    if (this.uploader.queue.length) {
      this.subscription = from(this.uploader.queue)
        .pipe(
          map(uploadingFile => uploadingFile._file),
          concatMap(uploadingFile => this.uploadFile(uploadingFile)),
          tap(response => this.fileUnloaded(response)),
          finalize(() => this.finishUpload()),
          takeUntil(this.unsubscribe)
        ).subscribe();
    }
  }

  private fileUnloaded(data: FileUpload) {
    console.log(data);

    if (data.progress != undefined) {
      this.progress = data.progress;
    }

    if ('response' in data) {
      let response = data.response;
      if (response != undefined && 'success' in response && !response.success) {
        const link = response.data !== 'Entity already presented' ? '<a href="/cabinet/dam/item/edit/${response.data}" target="_blank"></a>' : '';
        this.warningToast('Данный файл уже загружен ранее' + link);
      }
      if (response != undefined && 'success' in response && response.success) {
        this.files.push(data.response);
        this.onFileUnloaded.emit(data);
      }
      this.progress = 0;
    }
    this.cdr.detectChanges();
  }

  finishUpload(): void {
    this.uploader.clearQueue();
    this.subscription.unsubscribe();
    this.finished = true;
    this.isUploading = false;
    this.cdr.detectChanges();
  }

  uploadFile(uploadingFile: File): Observable<FileUpload> {
    console.log('uploadFile Type of File', uploadingFile instanceof File);
    console.log('uploadFile Argument', uploadingFile);
    if (!this.uploadURI) {
      this.uploadURI = '/dam/upload/' + this.catalogId;
    }
    console.log(this.uploadURI);
    return this.compoApiService.postFormWithProgress<DocumentFile, string>(
      this.uploadURI, {enabled: true, header: uploadingFile?.name, fileInput: uploadingFile}
    );
  }

}
